// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: Arial, sans-serif;
    background-color: #f4f4f4;
}

header {
    background: #007bff;
    color: #fff;
    padding: 20px 0;
    text-align: center;
}

h1 {
    margin: 0;
    font-size: 2.5em;
}

nav {
    margin-top: 10px;
}

nav a {
    color: #fff;
    text-decoration: none;
    margin: 0 15px;
}

nav a:hover {
    text-decoration: underline;
}

.container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 0 20px;
}

.system-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
}

.system-card {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
}

.system-card:hover {
    transform: scale(1.05);
}

.system-card img {
    width: 100%;
    height: auto;
}

.system-card h2 {
    font-size: 1.5em;
    margin: 10px;
}

.system-card a {
    display: block;
    text-align: center;
    padding: 10px;
    background: #007bff;
    color: #fff;
    text-decoration: none;
}

.system-card a:hover {
    background: #0056b3;
}

footer {
    background: #333;
    color: #fff;
    text-align: center;
    padding: 10px 0;
    position: relative;
    bottom: 0;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf","sourcesContent":["body {\n    margin: 0;\n    font-family: Arial, sans-serif;\n    background-color: #f4f4f4;\n}\n\nheader {\n    background: #007bff;\n    color: #fff;\n    padding: 20px 0;\n    text-align: center;\n}\n\nh1 {\n    margin: 0;\n    font-size: 2.5em;\n}\n\nnav {\n    margin-top: 10px;\n}\n\nnav a {\n    color: #fff;\n    text-decoration: none;\n    margin: 0 15px;\n}\n\nnav a:hover {\n    text-decoration: underline;\n}\n\n.container {\n    max-width: 1200px;\n    margin: 20px auto;\n    padding: 0 20px;\n}\n\n.system-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 20px;\n}\n\n.system-card {\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s;\n}\n\n.system-card:hover {\n    transform: scale(1.05);\n}\n\n.system-card img {\n    width: 100%;\n    height: auto;\n}\n\n.system-card h2 {\n    font-size: 1.5em;\n    margin: 10px;\n}\n\n.system-card a {\n    display: block;\n    text-align: center;\n    padding: 10px;\n    background: #007bff;\n    color: #fff;\n    text-decoration: none;\n}\n\n.system-card a:hover {\n    background: #0056b3;\n}\n\nfooter {\n    background: #333;\n    color: #fff;\n    text-align: center;\n    padding: 10px 0;\n    position: relative;\n    bottom: 0;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
